exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-post-temp-tsx": () => import("./../../../src/templates/post_temp.tsx" /* webpackChunkName: "component---src-templates-post-temp-tsx" */)
}

